import app from '../app';

const hoursOnly = /^[\d]{1,2}$/;
const hoursAndMins = /^[\d]{1,2}:[\d]{1,2}$/;

app.directive('cianAfValidateTime', () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, element, attrs, ngModel) => {
                const checkTime = input => {
                    let isValid = input ? false : true; // если есть данные по дефолту значение не валидное

                    if (hoursOnly.test(input)) {
                        const hours = Number(input);
                        isValid = hours < 24
                    }
                    else if (hoursAndMins.test(input)) {
                        const [hours, mins] = input.split(':').map(Number);
                        isValid = hours < 24 && mins < 60;
                    }

                    return isValid;
                };
                ngModel.$validators.time = checkTime;
            }
        };
    })
    .name;
